import type { NextPage } from "next";

import { useTranslation } from "@/app/i18n/client";
import Information from "@/components/icons/Informative/system/Information";
import { ColorSecondary } from "@/types/styles/designSystemEnum";
import { formatCurrencyPayment } from "@/utils/common/currencyHelper/currencyUtills";

export class ExtraChargeAgodaInterface {
  type: string;

  amount: number;

  excluded: boolean;

  name: string;

  currency: string;

  constructor(data: any) {
    this.type = data?.type || "";
    this.amount = data?.amount || 0;
    this.excluded = data?.excluded || false;
    this.name = data?.name || "";
    this.currency = data?.currency || "";
  }
}

interface HotelExtraChargeComponentProps {
  extraCharge: ExtraChargeAgodaInterface[];
}

const HotelExtraChargeComponent: NextPage<HotelExtraChargeComponentProps> = ({
  extraCharge,
}) => {
  const { t } = useTranslation("hotels");
  const payAtHotel = extraCharge
    .map(
      (item) =>
        `${item.name} ${t("extraChargeAgoda.payAtHotel")} <span class="font-bold text-base">${formatCurrencyPayment(item.amount, item.currency || "THB")}</span>`,
    )
    .join(", ");

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border-1 border-secondary-blue-base bg-secondary-blue-lighter p-4">
      <div className="flex gap-2">
        <div className="size-6 flex-none">
          <Information
            color={ColorSecondary.BLUE_BASE}
            height="100%"
            width="100%"
          />
        </div>
        <div dangerouslySetInnerHTML={{ __html: payAtHotel }} />
      </div>
    </div>
  );
};

export default HotelExtraChargeComponent;
